import React, { useState } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { UilArrowLeft } from '@iconscout/react-unicons';
import { createPaymentLoader, paymentVerify } from '../../redux/payment/actions';

function CheckoutForm() {
  const dispatch = useDispatch();
  const stripe = useStripe();
  const elements = useElements();
  const { id } = useParams();

  const userPaymentDetails = useSelector((state) => state.payment.userPaymentDetails);
  const loaderStatus = useSelector((state) => state.payment.createPaymentLoader);
  const businessData = useSelector((state) => state.payment.businessData);
  const language = useSelector((state) => state?.auth?.language);

  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    dispatch(createPaymentLoader(true));
    if (!stripe || !elements) {
      dispatch(createPaymentLoader(false)); // Stop the loader if stripe or elements are not ready
      return;
    }

    const { error: submitError } = await elements.submit();
    if (submitError) {
      setErrorMessage(submitError.message);
      dispatch(createPaymentLoader(false)); // Stop the loader if there's a submit error
      return;
    }

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      clientSecret: userPaymentDetails.client_secret,
      confirmParams: {
        return_url: `http://localhost:3001/pay/test-slug-new`,
      },
      redirect: 'if_required',
    });

    if (error) {
      setErrorMessage(error.message);
      dispatch(createPaymentLoader(false)); // Stop the loader if there's a payment error
      dispatch(paymentVerify(userPaymentDetails.payment_history_item.id));
    } else if (paymentIntent.status === 'succeeded') {
      dispatch(paymentVerify(userPaymentDetails.payment_history_item.id));
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />

      <div className="flex justify-between items-center pt-2" style={{ alignItems: 'center' }}>
        <div>
          <a
            href={`/pay/${id}`}
            className="flex"
            style={{ fontSize: '16px', fontWeight: '600', color: businessData?.colour || '#ffffff' }}
          >
            <UilArrowLeft className="mr-1" /> {language?.content?.BACK}
          </a>
        </div>
        <Button
          disabled={loaderStatus}
          type="default"
          style={{
            height: '50px',
            backgroundColor: businessData.colour || '#FF8C0',
            color: '#fff',
            fontWeight: 'bold',
            width: '176px',
            border: businessData.colour || '#FF8C0',
          }}
          htmlType="submit"
        >
          {loaderStatus
            ? 'Payment Processing'
            : `${
                userPaymentDetails?.payment_type === 'one_time' ? language?.content?.PAY : language?.content?.SUBSCRIBE
              } - €${userPaymentDetails?.amount}`}
        </Button>
      </div>

      {errorMessage && <div className="color-danger">{errorMessage}</div>}
    </form>
  );
}

export default CheckoutForm;
